<script>
import SpeciesOfInterestBase from './SpeciesOfInterestBase'

export default {
  name: 'SpeciesOfInterest',
  extends: SpeciesOfInterestBase,
  methods: {
    getHealthIndicatorTooltipText (speciesData) {
      switch (true) {
      case speciesData.isRelatedToBetterHealth &&
        speciesData.isSpecieRelatedToDisease:
        return this.i18n.t('general.associatedGood')
      case speciesData.isRelatedToBetterHealth:
        return this.i18n.t('general.associatedGood')
      case speciesData.isSpecieRelatedToDisease:
        return this.i18n.t('general.associatedPoor')
      }
    },
    showSpeciesDetails () {
      const payload = {
        item: {
          displayName: this.speciesData?.displayName,
          abundanceValue: this.speciesData?.abundanceValue,
          Level: this.speciesData?.level,
          sampleSpeciesUUID: this.speciesData?.sampleSpeciesUUID
        }
      }
      this.$emit('display:speciesDetails', payload)
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="row col-md-6 col-12">
      <div class="col-8 my-auto">
        <span
          href="#"
          class="species-name"
          @click.prevent="showSpeciesDetails()"
        >
          {{ speciesData.displayName }}
        </span>
      </div>
      <div class="col-4 my-auto">
        <TermButton
          :id="`tell-me-more-icon-${componentId}`"
          class="tell-me-more"
          :term-key="speciesData.displayName"
          :term-obj="speciesData"
          @onClickTerm="showSpeciesDetails()"
        />
        <b-tooltip :target="`tell-me-more-icon-${componentId}`">
          <span v-html="i18n.t('general.tellMeMore')" />
        </b-tooltip>
        <img
          v-if="getHealthIndicatorImageUrl(speciesData)"
          :id="`indicator-icon-${componentId}`"
          :src="getHealthIndicatorImageUrl(speciesData)"
          class="health-indicator-icon"
        >
        <b-tooltip :target="`indicator-icon-${componentId}`">
          <span v-html="getHealthIndicatorTooltipText(speciesData)" />
        </b-tooltip>
      </div>
    </div>
    <div class="row col-md-6 col-12">
      <div
        class="my-1"
        :class="!containsMultipleSamples ? 'col-10' : 'col-12'"
      >
        <div class="abundance-meter">
          <AbundanceMeter
            :enable-tooltip="true"
            :primary-sample="primaryAbundanceValue"
            :secondary-sample="secondaryAbundanceValue"
            :healthy-comparison="healthyCohortComparisonValue"
            :chart-id="componentId"
            :domain-min="domainMin"
            :domain-max="domainMax"
          />
        </div>
      </div>
      <div
        v-if="!containsMultipleSamples"
        class="col-2 my-auto abundance-level"
      >
        <span>
          {{ speciesData.level }}
        </span>
      </div>
    </div>
  </div>
</template>
